export const SerializedSpacerGateType = '…'

export type SerializedSpacerGate = {
  type: typeof SerializedSpacerGateType
  targets: number[]
}
